var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component, Children, cloneElement, isValidElement } from "react";
import { values as objValues, entries } from "lodash";
import { ReportingFilterOption } from "@irati/types";
import { injectIntl } from "@irati/utils/lang";
import { Hr } from "@irati/ui/src/Layout";
import { Radio, CustomNodeRenderer } from "@irati/ui/src/FormItem";
import Flex from "@irati/ui/src/Flex";
import { PastRangePicker as DateRangePicker, DatePreset, getStartAndEndDatesForPreset } from "@irati/ui/src/temp/DateRangePicker";
import { addQueryToUrl, addQueriesToUrl, buildFiltersFromSearch, getDatesFromSearch, searchToObject, generateSegmentOptions } from "../helpers";
import { FilterExpander, chartTypeToggleOptions } from ".";
import { FilterSectionDiv, FilterSectionFlex, MinWidthSelect } from "./styled";
var SegmentAndFilterWrapper = /** @class */ (function (_super) {
    __extends(SegmentAndFilterWrapper, _super);
    function SegmentAndFilterWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.searchDatesOrDefaults = function (search) {
            var _a = getDatesFromSearch(search), searchPreset = _a.preset, searchStartDate = _a.startDate, searchEndDate = _a.endDate;
            var preset;
            var startDate;
            var endDate;
            if (searchStartDate && searchEndDate) {
                startDate = new Date(searchStartDate);
                endDate = new Date(searchEndDate);
                preset = searchPreset;
            }
            else {
                preset = (searchPreset && objValues(DatePreset).includes(searchPreset)) ?
                    searchPreset :
                    DatePreset.LAST_TWELVE_MONTHS;
                var _b = getStartAndEndDatesForPreset(preset), presetStartDate = _b[0], presetEndDate = _b[1];
                startDate = presetStartDate;
                endDate = presetEndDate;
            }
            return { preset: preset, startDate: startDate, endDate: endDate };
        };
        _this.handleFilterApply = function () {
            var provisionalFilters = _this.state.provisionalFilters;
            if (provisionalFilters) {
                addQueriesToUrl(provisionalFilters);
            }
        };
        _this.fetchData = function () {
            var _a = _this.props, fetch = _a.fetch, search = _a.search;
            var _b = _this.searchDatesOrDefaults(search), startDateRaw = _b.startDate, endDateRaw = _b.endDate;
            var startDate = startDateRaw.toISOString();
            var endDate = endDateRaw.toISOString();
            var filterVariables = _this.generateFilterHeaders();
            var selectedSegment = _this.getSelectedSegment(search);
            fetch(startDate, endDate, selectedSegment, filterVariables);
        };
        _this.updateDates = function (_a) {
            var startDate = _a.startDate, endDate = _a.endDate, preset = _a.preset;
            addQueriesToUrl({ startDate: startDate.toISOString(), endDate: endDate.toISOString(), preset: preset });
        };
        _this.updateSegment = function (newSegment) { return addQueryToUrl("segment", newSegment); };
        _this.allowFilter = function (filter) { var _a; return (_a = _this.props.filters) === null || _a === void 0 ? void 0 : _a.includes(filter); };
        _this.updateFilter = function (filter, value) {
            var _a = _this.state.provisionalFilters, provisionalFilters = _a === void 0 ? {} : _a;
            provisionalFilters[filter] = Array.isArray(value) ? value.join(",") : value;
            _this.setState({ provisionalFilters: provisionalFilters });
        };
        _this.getSelectedSegment = function (search) {
            var segment = searchToObject(search).segment;
            return segment;
        };
        var search = props.search, filters = props.filters;
        _this.state = {
            provisionalFilters: buildFiltersFromSearch(search, filters)
        };
        return _this;
    }
    SegmentAndFilterWrapper.prototype.componentDidMount = function () {
        this.fetchData();
    };
    SegmentAndFilterWrapper.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.search !== prevProps.search) {
            this.fetchData();
        }
    };
    SegmentAndFilterWrapper.prototype.generateFilterHeaders = function () {
        var filterHeaders = searchToObject(this.props.search);
        return entries(filterHeaders).map(function (_a) {
            var type = _a[0], value = _a[1];
            return {
                type: type,
                values: (value || "").split(",")
            };
        });
    };
    SegmentAndFilterWrapper.prototype.render = function () {
        var _this = this;
        var _a = this.props, segments = _a.segments, filters = _a.filters, search = _a.search, formatMessage = _a.formatMessage, handleViewChange = _a.handleViewChange, view = _a.view, children = _a.children;
        var _b = this.state.provisionalFilters, filterValues = _b === void 0 ? {} : _b;
        var _c = this.searchDatesOrDefaults(search), startDate = _c.startDate, endDate = _c.endDate, preset = _c.preset;
        var selectedSegment = this.getSelectedSegment(search);
        var showSegments = segments && segments.length > 0;
        var showFilters = filters && filters.length > 0;
        if (!showSegments && !showFilters)
            return null;
        var segmentOptions = generateSegmentOptions(segments, formatMessage);
        var wrappedChildren = Children.map(children, function (child) {
            return isValidElement(child)
                ? cloneElement(child, {
                    startDate: startDate,
                    endDate: endDate,
                    preset: preset,
                    selectedSegment: (segmentOptions.find(function (segment) { return segment.value === selectedSegment; }) || {}).label
                })
                : child;
        });
        return (React.createElement(React.Fragment, null,
            React.createElement(Flex, { width: "100%" },
                React.createElement(FilterSectionFlex, { flex: "1", margin: "0 15px 0 0", alignItems: "center", justifyContent: "space-between" },
                    React.createElement("div", null,
                        React.createElement(MinWidthSelect, { value: { label: formatMessage({ id: "admin.reportingV3.drilldown.redemptionTitle" }), value: "redemptions" }, options: [{ label: formatMessage({ id: "admin.reportingV3.drilldown.redemptionTitle" }), value: "redemptions" }], isSearchable: false, isClearable: false, name: "drilldownRouteSelect", onChange: function () { } })),
                    React.createElement(DateRangePicker, { startDate: new Date(startDate), endDate: new Date(endDate), preset: preset, onSave: this.updateDates, defaultToPreset: true })),
                React.createElement(FilterSectionFlex, { width: "23%" },
                    React.createElement(Radio, { rowRenderer: CustomNodeRenderer, onChange: handleViewChange, value: view, options: chartTypeToggleOptions }))),
            showSegments && (React.createElement(FilterSectionDiv, null,
                React.createElement(Radio, { label: formatMessage({ id: "admin.reportingV3.segmentAndFilter.segmentTitle" }), value: selectedSegment, inline: true, onChange: function (segment) { return _this.updateSegment(segment); }, options: segmentOptions }))),
            showFilters && (React.createElement(FilterExpander, { filterChangeHandler: this.updateFilter, filterValues: filterValues, handleApply: this.handleFilterApply, filters: [
                    ReportingFilterOption.PerkCategory,
                    ReportingFilterOption.PerkUuid,
                    ReportingFilterOption.PerkType,
                    ReportingFilterOption.Team
                ] })),
            React.createElement(Hr, null),
            wrappedChildren));
    };
    return SegmentAndFilterWrapper;
}(Component));
export default injectIntl(SegmentAndFilterWrapper);
